__turbopack_context__.v({
  "checkoutDisabled": "Checkout-module__mwfL-q__checkoutDisabled",
  "container": "Checkout-module__mwfL-q__container",
  "dummyPaymentBadge": "Checkout-module__mwfL-q__dummyPaymentBadge",
  "dummyPaymentBadgeNoBorder": "Checkout-module__mwfL-q__dummyPaymentBadgeNoBorder",
  "dummyPaymentContainer": "Checkout-module__mwfL-q__dummyPaymentContainer",
  "dummyPaymentMessage": "Checkout-module__mwfL-q__dummyPaymentMessage",
  "eyebrow": "Checkout-module__mwfL-q__eyebrow",
  "heading": "Checkout-module__mwfL-q__heading",
});
